/**
 * AutorisationAbsence (Absence Authorization) Types for HR Module
 */

export type StatutAutorisation = 'EN_ATTENTE' | 'AUTORISEE' | 'REFUSEE';

export interface EmployeeInfo {
  id: number;
  matricule: string;
  nom_complet: string;
  fonction: string | null;
  date_embauche: string | null;
  cin: string | null;
}

export interface ValidatorInfo {
  id: number;
  email: string;
  name: string | null;
}

export interface AutorisationAbsence {
  id: number;
  ref_autorisation: string | null;
  employee_id: number;
  employee: EmployeeInfo | null;
  date_debut: string;
  date_fin: string;
  nbr_jours: number;
  motif: string | null;
  statut: StatutAutorisation;
  validated_by: number | null;
  validator: ValidatorInfo | null;
  validated_at: string | null;
  commentaire_rh: string | null;
  created_at: string;
  updated_at: string | null;
}

export interface AutorisationAbsenceCreate {
  employee_id: number;
  date_debut: string;
  date_fin: string;
  motif?: string | null;
}

export interface AutorisationAbsenceUpdate {
  date_debut?: string;
  date_fin?: string;
  motif?: string | null;
}

export interface AutorisationAbsenceValidate {
  statut: StatutAutorisation;
  commentaire_rh?: string | null;
}

export interface AutorisationAbsenceListResponse {
  items: AutorisationAbsence[];
  total: number;
  page: number;
  size: number;
  pages: number;
}

export interface AutorisationAbsenceStats {
  total_demandes: number;
  total_en_attente: number;
  total_autorisees: number;
  total_refusees: number;
}

// Constants for dropdowns
export const STATUT_AUTORISATION_OPTIONS: { value: StatutAutorisation; label: string; color: string }[] = [
  { value: 'EN_ATTENTE', label: 'En attente', color: 'warning' },
  { value: 'AUTORISEE', label: 'Autorisee', color: 'success' },
  { value: 'REFUSEE', label: 'Refusee', color: 'error' },
];

export const getStatutAutorisationLabel = (statut: StatutAutorisation): string => {
  const option = STATUT_AUTORISATION_OPTIONS.find(o => o.value === statut);
  return option?.label || statut;
};

export const getStatutAutorisationColor = (statut: StatutAutorisation): 'warning' | 'success' | 'error' | 'default' => {
  const option = STATUT_AUTORISATION_OPTIONS.find(o => o.value === statut);
  return (option?.color as 'warning' | 'success' | 'error') || 'default';
};
